module.exports = __webpack_public_path__ + "static/media/perf.e23d0a84.png";